import React from "react";
import Location from "./TaskLocation";
import { Link, withRouter } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Button from "react-bootstrap/Button";
import moment from "moment";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import axios from "axios";
import { API_ROOT, API_HOST } from "../utils/api-config";
import SweetAlert from "react-bootstrap-sweetalert";
import Table from "react-bootstrap/Table";
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";
import { history } from "../../Root";

let token = "Bearer " + localStorage.getItem("token");
const config = {
  headers: {
    Authorization: token,
    "Content-Type": "application/x-www-form-urlencoded",
  },
};
const auth = {
  headers: {
    Authorization: token,
  },
};
class RouteTasks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      driver_id: 0,
      add_task: 0,
      showRemove: false,
      showDelete: false,
      showComplete: false,
      showRemoveDone: false,
      showCompleteDone: false,
      showDriver: false,
      showTaskAdded: false,
      showPickups: false,
      checkboxes: {},
      showMap: null,
      address1: "",
      address2: "",
      city: "",
      zip: "",
      province: "",
      title: "",
      instructions: "",
      lat: "",
      lng: "",
    };
    this.handleConfirm = this.handleConfirm.bind(this);
    this.hideCompleteAlert = this.hideCompleteAlert.bind(this);
    this.hideRemoveAlert = this.hideRemoveAlert.bind(this);
    this.hideDriverAlert = this.hideDriverAlert.bind(this);
    this.hideTaskAddedAlert = this.hideTaskAddedAlert.bind(this);
    this.hidePickupsAlert = this.hidePickupsAlert.bind(this);
    this.hideDeleteAlert = this.hideDeleteAlert.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleTaskConfirm = this.handleTaskConfirm.bind(this);
    this.handleComplete = this.handleComplete.bind(this);
    this.handlePickupsConfirm = this.handlePickupsConfirm.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.props;
    this.props.tasksInfo.task.map(
      (data) =>
        data.task_type == "pickup" &&
        this.setState((prevState) => {
          return {
            checkboxes: {
              ...prevState.checkboxes,
              [data.id]: false,
            },
          };
        })
    );

    this.setState({
      driver_id: this.props.tasksInfo.route.driver_id
        ? this.props.tasksInfo.route.driver_id
        : 0,
    });
  }
  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };
  handleAddressChange = (address) => {
    const split = address.split(", ");
    this.setState({ address1: split[0], city: split[1], province: split[2] });
  };
  handleSelect = (selected) => {
    geocodeByAddress(selected)
      .then((results) => this.handleResultsState(results))
      .catch((error) => console.error("Error", error));
  };
  handleResultsState = (results) => {
    console.log(results);
    const split = results[0].formatted_address.split(", ");

    this.setState({
      address1: split[0],
      city: results[0].address_components[3].long_name,
      province: results[0].address_components[5].long_name,
      zip: results[0].address_components[7].long_name,
      lat: results[0].geometry.location.lat(),
      lng: results[0].geometry.location.lng(),
    });
  };
  toggleShow = (id) =>
    this.setState({ showMap: this.state.showMap === id ? null : id });
  createOptions = () =>
    this.props.tasksInfo.drivers.map((data) => (
      <option key={data.id} value={data.id}>
        {data.first_name}
      </option>
    ));
  createTaskOptions = () =>
    this.props.tasksInfo.unroutedTasks.map((data) => (
      <option key={data.id} value={data.id}>
        {data.title} - {data.name}
      </option>
    ));
  redirect = () => {
    this.props.history.push({
      pathname: "/logistics",
    });
  };
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  handleChange(event) {
    const name = event.target.name;
    const value = event.target.checked;

    this.setState((prevState) => {
      return {
        checkboxes: { ...prevState.checkboxes, [name]: value },
      };
    });
  }
  handleTaskConfirm(e) {
    e.preventDefault();

    const formData = new FormData();

    formData.append("task_id", this.state.add_task);
    formData.append("address1", this.state.address1);
    formData.append("address2", this.state.address2);
    formData.append("city", this.state.city);
    formData.append("zip", this.state.zip);
    formData.append("province", this.state.province);
    formData.append("lat", this.state.lat);
    formData.append("lng", this.state.lng);
    formData.append("title", this.state.title);
    formData.append("instructions", this.state.instructions);
    formData.append("_method", "patch");

    axios
      .post(
        `${API_ROOT}/routes/addtask?id=${this.props.tasksInfo.route.id}`,
        formData,
        config
      )
      .then((response) => console.log(response.data))
      .then(() => this.setState({ showTaskAdded: true, add_task: "Choose..." }))
      .then(() => this.props.getTasksInfo())
      .catch((error) => console.log("api errors:", error));
  }

  handleConfirm(e) {
    e.preventDefault();

    const formData = new FormData();

    formData.append("route[driver_id]", this.state.driver_id);
    formData.append("_method", "patch");

    axios
      .post(
        `${API_ROOT}/routes/assigndriver?id=${this.props.tasksInfo.route.id}`,
        formData,
        config
      )
      .then((response) => console.log(response.data))
      .then(() => this.setState({ showDriver: true }))
      .then(() => this.props.getTasksInfo())
      .catch((error) => console.log("api errors:", error));
  }
  handleComplete(type, transit, id, ids) {
    this.hideCompleteAlert();

    const data =
      type === "delivery"
        ? {
            task_id: id,
            delivery_id: ids[0],
          }
        : {
            task_id: id,
            delivery_ids: ids,
          };
    const task_type = type === "pickup" || transit ? "pickup" : "delivered";

    axios
      .post(`${API_ROOT}/tasks/${task_type}`, data, auth)
      .then((response) => console.log(response.data))
      .then(() => this.setState({ showCompleteDone: true }))
      .then(() => this.props.getTasksInfo())
      .catch((error) => console.log("api errors:", error));
  }
  handlePickupsConfirm(e) {
    e.preventDefault();

    const formData = new FormData();
    this.props.tasksInfo.task.map((task) => {
      if (this.state.checkboxes[task.id])
        formData.append("task_ids[]", task.id);
    });

    axios
      .post(`${API_ROOT}/tasks/pickups`, formData, config)
      .then((response) => console.log(response.data))
      .then(() => this.setState({ showPickups: true }))
      .then(() => this.props.getTasksInfo())
      .catch((error) => console.log("api errors:", error));
    setTimeout(() => {}, 1500);
  }
  handleRemove(id, pickup) {
    this.hideRemoveAlert();
    const formData = new FormData();
    formData.append("pickup", pickup);

    axios
      .put(`${API_ROOT}/tasks/${id}`, formData, config)
      .then((response) => console.log(response.data))
      .then(() => this.props.getTasksInfo())
      .catch((error) => console.log("api errors:", error));
  }

  handleClick = (id) => {
    axios
      .get(`${API_ROOT}/deliveries/${id}`, auth)
      .then((response) =>
        history.push(`/fulfillments/${response.data.delivery.order_id}`)
      );
  };

  handleDelete(id) {
    this.hideDeleteAlert();

    axios
      .delete(`${API_ROOT}/routes/${id}`, config)
      .then((response) => this.redirect())
      .catch((error) => console.log("api errors:", error));
  }
  hideDriverAlert() {
    this.setState({ showDriver: false });
  }
  hideTaskAddedAlert() {
    this.setState({ showTaskAdded: false });
  }
  hidePickupsAlert() {
    this.setState({ showPickups: false });
  }
  hideRemoveAlert() {
    this.setState({ showRemove: false });
  }
  hideCompleteAlert() {
    this.setState({ showComplete: false });
  }
  hideDeleteAlert() {
    this.setState({ showDelete: false });
  }

  showDriverAlert() {
    this.setState({ showDriver: true });
  }
  showTaskAddedAlert() {
    this.setState({ showTaskAdded: true });
  }

  render() {
    const { route, task, items } = this.props.tasksInfo;
    const orderedTasks = route.tasks
      .map((id) => task.find((x) => x.id == id))
      .map((x) => x);

    return (
      <div>
        <h4 className="text-center">
          Route {route.id} - {route.delivery_ids.length}{" "}
          {route.delivery_ids.length > 1 ? "deliveries" : "delivery"}
        </h4>
        <Accordion>
          {orderedTasks.map((tsk, i) => {
            let variant =
              orderedTasks[i].task_type === "pickup"
                ? "outline-primary"
                : "outline-secondary";
            return (
              !orderedTasks[i].complete && (
                <Card key={i}>
                  <Accordion.Toggle
                    as={Button}
                    variant={
                      orderedTasks[i].started ? "outline-warning" : variant
                    }
                    eventKey={`${orderedTasks[i].id}`}
                  >
                    {orderedTasks[i].title}
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={`${orderedTasks[i].id}`}>
                    <Card.Body>
                      {orderedTasks[i].name}{" "}
                      {orderedTasks[i].task_type === "delivery" &&
                        `(${orderedTasks[i].merchant} - 
                      ${orderedTasks[i].orders[0]})`}
                      <br></br>
                      {orderedTasks[i].address1} {orderedTasks[i].address2},{" "}
                      {orderedTasks[i].city}, {orderedTasks[i].province},{" "}
                      {orderedTasks[i].postal_code} <br></br>
                      Instructions:{" "}
                      {orderedTasks[i].delivery_instructions &&
                        orderedTasks[i].delivery_instructions}
                      {orderedTasks[i].task_type === "pickup" &&
                      !orderedTasks[i].pick_up
                        ? orderedTasks[i].delivery_ids.map((del, i) => {
                            const task_items = items.find((item) => {
                              return item[del];
                            });
                            return (
                              <div key={i}>
                                <p className="font-weight-bold">
                                  {task_items[del].order}
                                </p>
                                {task_items[del].items &&
                                  task_items[del].items.length > 0 && (
                                    <Table striped bordered hover responsive>
                                      <thead>
                                        <tr className="table-primary">
                                          <th>Item</th>
                                          <th>Quantity</th>
                                          <th>Weight, kg</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {task_items[del].items.map((item) => {
                                          return (
                                            <tr
                                              key={item.id}
                                              className="table-info"
                                            >
                                              <td>{item.name}</td>
                                              <td>{item.quantity}</td>
                                              <td>{item.grams / 1000}</td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </Table>
                                  )}
                              </div>
                            );
                          })
                        : ""}
                      <br></br>
                      <br></br>
                      {orderedTasks[i].pick_up_time &&
                        task.driver_id &&
                        `Picked Up By: 
                    ${driver.first_name} at ${moment(task.pick_up_time).format(
                          "MMMM Do YYYY, h:mm:ss a"
                        )}`}
                      <ButtonGroup aria-label="Basic example">
                        {this.state.showComplete && (
                          <SweetAlert
                            type="success"
                            title="You are going to complete the task!"
                            onConfirm={() =>
                              this.handleComplete(
                                orderedTasks[i].task_type,
                                orderedTasks[i].transit,
                                orderedTasks[i].id,
                                orderedTasks[i].delivery_ids
                              )
                            }
                            onCancel={this.hideCompleteAlert}
                            showCancel={true}
                            confirmBtnText="Complete"
                            confirmBtnBsStyle="success"
                            closeAnim={{
                              name: "hideSweetAlert",
                              duration: 100,
                            }}
                          />
                        )}
                        <Button
                          variant="success"
                          onClick={() => this.setState({ showComplete: true })}
                        >
                          Complete Task
                        </Button>
                        {this.state.showRemove ? (
                          orderedTasks[i].task_type == "pickup" ? (
                            <SweetAlert
                              type="danger"
                              title="You are going to remove the task!"
                              onConfirm={() =>
                                this.handleRemove(orderedTasks[i].id, true)
                              }
                              onCancel={this.hideRemoveAlert}
                              showCancel={true}
                              confirmBtnText="Remove"
                              confirmBtnBsStyle="danger"
                            />
                          ) : (
                            <SweetAlert
                              type="danger"
                              title="You are going to remove the task!"
                              onConfirm={() =>
                                this.handleRemove(orderedTasks[i].id, false)
                              }
                              onCancel={this.hideRemoveAlert}
                              showCancel={true}
                              showConfirm={false}
                              // confirmBtnText="Remove"
                              // confirmBtnBsStyle="danger"
                              type={"controlled"}
                            >
                              <div>
                                <Button
                                  variant="success"
                                  onClick={() =>
                                    this.handleRemove(orderedTasks[i].id, true)
                                  }
                                >
                                  Delete With Pickup Task
                                </Button>
                                &nbsp;
                                <Button
                                  variant="danger"
                                  onClick={() =>
                                    this.handleRemove(orderedTasks[i].id, false)
                                  }
                                >
                                  Delete Only This Task
                                </Button>
                              </div>
                            </SweetAlert>
                          )
                        ) : null}
                        <Link to={`/tasks/${orderedTasks[i].id}`}>
                          <Button variant="info">Edit Task</Button>
                        </Link>
                        <Button
                          variant="danger"
                          onClick={() => this.setState({ showRemove: true })}
                        >
                          Remove Task
                        </Button>

                        <a
                          href={
                            orderedTasks[i].task_type == "delivery"
                              ? `https://delivery.mile1.ca/track?t=${orderedTasks[i].id}96`
                              : orderedTasks[i].pick_up
                              ? `https://delivery.mile1.ca/track?t=${orderedTasks[i].id}96`
                              : `https://delivery.mile1.ca/track?t=${orderedTasks[i].id}96`
                          }
                          target="_blank"
                        >
                          <Button variant="primary">Tracking View</Button>
                        </a>
                        {orderedTasks[i].title.includes("between") && (
                          <Button
                            variant="info"
                            onClick={() =>
                              this.handleClick(orderedTasks[i].delivery_ids[0])
                            }
                          >
                            Delivery Details
                          </Button>
                        )}
                        <Button
                          variant="secondary"
                          onClick={() => this.toggleShow(orderedTasks[i].id)}
                        >
                          {this.state.showMap === orderedTasks[i].id
                            ? "Hide Map"
                            : "Show Map"}
                        </Button>
                      </ButtonGroup>
                      {this.state.showMap === orderedTasks[i].id && (
                        <Location
                          address={orderedTasks[i].address1}
                          city={orderedTasks[i].city}
                          province={orderedTasks[i].province}
                          zip={orderedTasks[i].postal_code}
                        />
                      )}
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              )
            );
          })}
        </Accordion>
        <br></br>
        {this.state.add_task == "Custom" && (
          <Card>
            <Card.Title>New Custom Task</Card.Title>
            <Card.Body>
              <Form.Row>
                <Form.Group as={Col} controlId="formGridTitle">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    name="title"
                    onChange={this.handleInputChange}
                  />
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} controlId="formGridInstructions">
                  <Form.Label>Instructions</Form.Label>
                  <Form.Control
                    name="instructions"
                    onChange={this.handleInputChange}
                  />
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} controlId="formGridAddress">
                  <Form.Label>Address</Form.Label>
                  <PlacesAutocomplete
                    value={this.state.address1}
                    onChange={this.handleAddressChange}
                    onSelect={this.handleSelect}
                    searchOptions={{
                      location: new google.maps.LatLng(43.65107, -79.347015),
                      radius: 2000,
                      types: ["address"],
                    }}
                  >
                    {({
                      getInputProps,
                      suggestions,
                      getSuggestionItemProps,
                      loading,
                    }) => (
                      <div>
                        <Form.Control {...getInputProps()} />
                        <div className="autocomplete-dropdown-container">
                          {loading && <div>Loading...</div>}
                          {suggestions.map((suggestion) => {
                            const className = suggestion.active
                              ? "suggestion-item--active"
                              : "suggestion-item";
                            // inline style for demonstration purpose
                            const style = suggestion.active
                              ? {
                                  backgroundColor: "lightblue",
                                  cursor: "pointer",
                                }
                              : {
                                  backgroundColor: "#ffffff",
                                  cursor: "pointer",
                                };
                            return (
                              <div
                                {...getSuggestionItemProps(suggestion, {
                                  className,
                                  style,
                                })}
                              >
                                <span>{suggestion.description}</span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </PlacesAutocomplete>
                </Form.Group>
                <Form.Group as={Col} md="3" controlId="formGridAddress2">
                  <Form.Label>Address 2</Form.Label>
                  <Form.Control
                    name="address2"
                    value={this.state.address2}
                    placeholder="Apartment, studio, or floor"
                    onChange={this.handleInputChange}
                  />
                </Form.Group>
              </Form.Row>

              <Form.Row>
                <Form.Group as={Col} controlId="formGridCity">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    name="city"
                    value={this.state.shipto_city}
                    onChange={this.handleInputChange}
                    as="select"
                  >
                    <option>Toronto</option>
                    <option>North York</option>
                    <option>East York</option>
                    <option>Etobicoke</option>
                    <option>Missisauga</option>
                  </Form.Control>
                </Form.Group>

                <Form.Group as={Col} controlId="formGridState">
                  <Form.Label>Province</Form.Label>
                  <Form.Control
                    name="province"
                    value={this.state.shipto_province}
                    onChange={this.handleInputChange}
                    as="select"
                  >
                    <option>Ontario</option>
                    <option>ON</option>
                  </Form.Control>
                </Form.Group>

                <Form.Group as={Col} controlId="formGridZip">
                  <Form.Label>Postal Code</Form.Label>
                  <Form.Control
                    value={this.state.zip}
                    name="zip"
                    onChange={this.handleInputChange}
                  />
                </Form.Group>
              </Form.Row>
            </Card.Body>
          </Card>
        )}
        <div className="container-fluid">
          <Row>
            <Col md="3">
              <Form className="mt-15" onSubmit={this.handleConfirm}>
                <Form.Row>
                  <Form.Group controlId="formDrivers">
                    <Form.Label>
                      <h4 className="mb-10">
                        {!route.driver_id ? "Assign Driver" : "Change Driver"}
                      </h4>
                    </Form.Label>
                    <Form.Control
                      name="driver_id"
                      onChange={this.handleInputChange}
                      value={this.state.driver_id}
                      as="select"
                    >
                      <option>Choose...</option>
                      {this.createOptions()}
                    </Form.Control>
                  </Form.Group>
                </Form.Row>
                <Button variant="primary" type="submit">
                  Confirm
                </Button>
              </Form>
              {this.state.showDriver && (
                <SweetAlert
                  type="success"
                  title="Driver was assigned"
                  onConfirm={this.hideDriverAlert}
                  showCancel={false}
                  confirmBtnText="OK"
                  confirmBtnBsStyle="success"
                  closeAnim={{
                    name: "hideSweetAlert",
                    duration: 100,
                  }}
                />
              )}
            </Col>
            <Col md="3">
              <Form className="mt-15" onSubmit={this.handleTaskConfirm}>
                <Form.Row>
                  <Form.Group controlId="formTasks">
                    <Form.Label>
                      <h4 className="mb-10">Add Task to Route</h4>
                    </Form.Label>
                    <Form.Control
                      name="add_task"
                      onChange={this.handleInputChange}
                      value={this.state.add_task}
                      as="select"
                    >
                      <option>Choose...</option>
                      <option>Custom</option>
                      <option>Stop at DC</option>
                      {this.createTaskOptions()}
                    </Form.Control>
                  </Form.Group>
                </Form.Row>
                <Button variant="primary" type="submit">
                  Add Task
                </Button>
              </Form>
              {this.state.showTaskAdded && (
                <SweetAlert
                  type="success"
                  title="Task has been added"
                  onConfirm={this.hideTaskAddedAlert}
                  showCancel={false}
                  confirmBtnText="OK"
                  confirmBtnBsStyle="success"
                  closeAnim={{
                    name: "hideSweetAlert",
                    duration: 100,
                  }}
                />
              )}
            </Col>
            <Col md="3">
              <Form className="mt-15" onSubmit={this.handlePickupsConfirm}>
                <Form.Row>
                  <Form.Group controlId="formPickups">
                    <Form.Label>
                      <h4 className="mb-10">Complete Pickups</h4>
                    </Form.Label>
                    {this.props.tasksInfo.task.map(
                      (task) =>
                        !task.complete &&
                        !task.transit &&
                        task.task_type == "pickup" && (
                          <Form.Check
                            key={task.id}
                            type="checkbox"
                            name={task.id}
                            checked={this.state.checkboxes[name]}
                            onChange={this.handleChange}
                            label={task.title}
                          />
                        )
                    )}
                  </Form.Group>
                </Form.Row>
                <Button variant="primary" type="submit">
                  Confirm
                </Button>
              </Form>
              {this.state.showPickups && (
                <SweetAlert
                  type="success"
                  title="Pickup tasks completed"
                  onConfirm={this.hidePickupsAlert}
                  showCancel={false}
                  confirmBtnText="OK"
                  confirmBtnBsStyle="success"
                  closeAnim={{
                    name: "hideSweetAlert",
                    duration: 100,
                  }}
                />
              )}
            </Col>
            <Col md="3">
              <Form className="mt-15">
                <Form.Row>
                  <Form.Group controlId="formDelete">
                    <Form.Label>
                      <h4 className="mb-10">DELETE ROUTE</h4>
                    </Form.Label>
                  </Form.Group>
                </Form.Row>
                {this.state.showDelete && (
                  <SweetAlert
                    type="danger"
                    title="You are going to delete the route!"
                    onConfirm={() => this.handleDelete(route.id)}
                    onCancel={this.hideDeleteAlert}
                    showCancel={true}
                    confirmBtnText="Delete"
                    confirmBtnBsStyle="danger"
                    closeAnim={{
                      name: "hideSweetAlert",
                      duration: 100,
                    }}
                  />
                )}
                <Button
                  variant="danger"
                  onClick={() => this.setState({ showDelete: true })}
                >
                  Delete
                </Button>
              </Form>
              {this.state.showPickups && (
                <SweetAlert
                  type="success"
                  title="Pickup tasks completed"
                  onConfirm={this.hidePickupsAlert}
                  showCancel={false}
                  confirmBtnText="OK"
                  confirmBtnBsStyle="success"
                  closeAnim={{
                    name: "hideSweetAlert",
                    duration: 100,
                  }}
                />
              )}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default withRouter(RouteTasks);
